import { useEffect, useState } from "react";
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from "framer-motion";
import { CONFIG, IMAGES } from "../../lib/config";

const nav = [
  { label: "Manifeste", href: "#manifeste" },
  { label: "Nokuji", href: "#nokuji" },
  { label: "Surprises", href: "#surprises" },
  { label: "LemFi", href: "#lemfi" },
  { label: "Line-up", href: "#lineup" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 40));

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-black/60 backdrop-blur-2xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1600px] items-center justify-between px-5 lg:px-10">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
          <span className="font-display text-2xl leading-none tracking-tight text-[#FF0000]">
            AKTRA
          </span>
          <span className="hidden font-mono-x text-[10px] uppercase tracking-[0.3em] text-zinc-500 sm:inline">
            présente
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="link-underline font-mono-x text-xs uppercase tracking-[0.2em] text-zinc-300 hover:text-white"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href={CONFIG.weezeventUrl}
          data-testid="header-buy-ticket"
          className="glow-red group flex items-center gap-2 bg-[#FF0000] px-5 py-2.5 font-mono-x text-xs font-semibold uppercase tracking-[0.15em] text-white hover:bg-[#ff2424]"
        >
          Acheter mon billet
          <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
        </a>
      </div>
    </motion.header>
  );
}
